module.exports = __webpack_public_path__ + "static/img/13.4c86de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c31/13.png
// module id = 6IW+
// module chunks = 0